<template>
    <el-card>
        <div class="announcement-header">
            <div class="announcement-icon">
                <i class="el-icon-location-outline"></i>
            </div>
            <div class="announcement-title">设备管理</div>
        </div>
        <div class="device-table-container">
            <div class="checkin-overview-list">
                <div class="overview-header">
                    <div class="header-item">设备ID</div>
                    <div class="header-item">设备名称</div>
                    <div class="header-item">设备类型</div>
                    <div class="header-item">下次维保时间</div>
                    <div class="header-item">所属功能间</div>
                    <div class="header-item">状态</div>
                </div>
                <!-- 滚动列表的视窗容器 -->
                <div class="marquee-container">
                    <div class="overview-body">
                        <div class="overview-row" v-for="(item, index) in deviceList" :key="index">
                            <div class="body-item">{{ item.id }}</div>
                            <div class="body-item">{{ item.deviceName }}</div>
                            <div class="body-item">{{ item.deviceType }}</div>
                            <div class="body-item"> {{ formatTime(item.nextMaintenance) }}</div>
                            <div class="body-item"> {{ getRoomName(item.roomId) }}</div>
                            <div class="body-item">
                                <el-tag
                                    :type="item.deviceStatus == 1 ? 'success' : (item.deviceStatus == 0 ? 'danger' : 'info')">
                                    {{ item.deviceStatus == 1 ? '在线' : item.deviceStatus == 0 ? '离线' : '未检测' }}
                                </el-tag>
                            </div>
                        </div>
                        <div class="empty-tip" v-if="deviceList.length === 0">
                            暂无设备数据
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-card>
</template>

<script>
export default {
    props: {
        deviceList: {
            type: Array,
            default: () => []
        },
        roomList: {
            type: Array,
            default: () => []
        }
    },
    mounted() {
        // 检查过期维保设备并通知父组件
        this.checkExpiredMaintenanceDevice();
    },
    methods: {
        formatTime(timeStr) {
            if (!timeStr) return "未设置";
            try {
                const date = new Date(timeStr);
                return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
            } catch (error) {
                return timeStr;
            }
        },

        getRoomName(roomId) {
            const room = this.roomList.find(item => item.id === roomId);
            return room ? room.roomName : '未知功能间';
        },

        checkExpiredMaintenanceDevice() {
            if (!this.deviceList.length) return;
            const now = new Date().getTime();
            const expiredList = this.deviceList.filter(item => {
                if (!item.nextMaintenance) return false;
                try {
                    return new Date(item.nextMaintenance).getTime() < now;
                } catch (error) {
                    return false;
                }
            });
            this.$emit('check-expired', expiredList);
        }
    }
};
</script>

<style lang="scss" scoped>
.announcement-header {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    padding: 10px 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 15px;

    .announcement-icon {
        color: #faad14;
        font-size: 20px;
        margin-right: 10px;
    }
}

.device-table-container {
    display: flex;
    flex-direction: column;
    height: calc(100% - 60px);
    overflow: hidden;
}

// --- 自动滚动列表样式 ---
.checkin-overview-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .overview-header {
        display: flex;
        background-color: #f8f9fa;
        font-weight: 600;
        padding: 12px 0;
        border-bottom: 1px solid #e8e8e8;
        z-index: 10;

        .header-item {
            flex: 1;
            text-align: center;
            color: #333;
        }
    }

    .marquee-container {
        flex: 1;
        overflow: hidden;
    }

    .overview-body {
        animation: scroll-up-device-table 60s linear infinite;
        height: 100%;

        &:hover {
            animation-play-state: paused;
        }

        .overview-row {
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px dashed #f0f0f0;

            &:hover {
                background-color: #f8f9fa;
            }

            .body-item {
                flex: 1;
                text-align: center;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .empty-tip {
            text-align: center;
            padding: 50px 0;
            color: #999;
        }
    }
}

// 设备列表滚动动画
@keyframes scroll-up-device-table {
    0% {
        transform: translateY(0);
    }

    100% {
        transform: translateY(calc(-100% + 30vh));
    }
}
</style>